import React, { useEffect, useRef } from 'react';
import * as d3 from "d3";


const Guage = (value) => {
    const svgRef = useRef();


    useEffect(() => {
        const svg = d3.select(svgRef.current)
            .attr("height", 181)
            .attr("width", 200);

        svg.selectAll("*").remove();

        const group = svg.append("g")
            .attr("transform", "translate(100, 100)");

        const r = 100;
        const p = Math.PI * 2;


        const height = 181;
        const width = 200;

        const arc = d3.arc()
            .innerRadius(r - 15)
            .outerRadius(r)
            .startAngle(p + 2)
            .endAngle(p - 2);


        group.append("path")
            .attr("d", arc)
            // .attr("fill", "#08b023");
            .attr("fill", 'url(#svgGradient)')


        const needleG = svg.append('g')
            .attr('transform', `translate(${width / 2}, ${height / 1.35})`)




        var defs = svg.append("defs");

        var gradient = defs.append("linearGradient")
            .attr("id", "svgGradient")
            .attr("x1", "0%")
            .attr("x2", "100%")
            .attr("y1", "0%")
            .attr("y2", "0%");

        gradient.append("stop")
            .attr('class', 'start')
            .attr("offset", "0%")
            .attr("stop-color", "#ff3f17")
            .attr("stop-opacity", 1);


        gradient.append("stop")
            .attr('class', 'start')
            .attr("offset", "25%")
            .attr("stop-color", "#f5ec57")
            .attr("stop-opacity", 1);

        gradient.append("stop")
            .attr('class', 'end')
            .attr("offset", "100%")
            .attr("stop-color", "#08b023")
            .attr("stop-opacity", 1);

        svg.append("text")
            .text(`${value && value.value && value.value.bat_pcs ? value.value.bat_pcs.soc !== null ? (value.value.bat_pcs.soc).toFixed(0) : "---" : "---"}`)
            .attr("x", `${value && value.value && value.value.hasOwnProperty('bat_pcs')
                ? value.value.bat_pcs.soc > 99
                    ? 75
                    : (value.value.bat_pcs.soc < 99 && value.value.bat_pcs.soc > 9) ? 86
                        : 95 : 85}`)
            .attr("y", 180)
            .style('fill', '#fdcd4c')
            .style('font', '32px Inter');

        svg.append("text")
            .text("%")
            .attr("x", `${value && value.value && value.value.hasOwnProperty('bat_pcs')
                ? value.value.bat_pcs.soc === 100
                    ? 140
                    : (value.value.bat_pcs.soc < 100 && value.value.bat_pcs.soc > 9) ? 135
                        : 125 : 140}`)
            .attr("y", 180)
            .style('fill', '#fdcd4c')
            .style('font', '22px Inter');

        const percentage = value && value.value && value.value.bat_pcs ? value.value.bat_pcs.soc !== null ? (value.value.bat_pcs.soc).toFixed(0) : "---" : "---";

        const needleLen = 70
        const needleRadius = 10

        const centerX = 0
        const centerY = 0

        const topX = centerX - 0
        const topY = centerY - needleLen

        const leftX = centerX - needleRadius
        const leftY = centerY - 0

        const rightX = centerX - -(needleRadius)
        const rightY = centerY - 0

        const percToDeg = (perc) => {
            const Calc = (perc * 360) / 100;
            let degree;
            if (perc < 50) {
                degree = (Calc / 2) - 90;
            } else {
                degree = (Calc / 2) - 90;
            }
            return degree;
        }

        needleG.append('path')
            .attr('d', `M ${leftX} ${leftY} L ${topX} ${topY} L ${rightX} ${rightY}`)
            .attr("fill", "#b4b2b2")

            //-90 is 0%
            //90 is 100%
            .attr('transform', `rotate(${percentage === "---" ? percToDeg(0) : percToDeg(percentage)})`);



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <>
            {/* {drawChart()} */}
            <svg ref={svgRef} />
        </>

    );
}

export default Guage;